export enum BackgroundGenerationStatus {
  Pending = 1,
  Completed = 2,
  Error = 3,
}
